import { isAfter, isBefore, startOfDay } from 'date-fns';
import Entry from 'garaje/models/entry';
import Invite from 'garaje/models/invite';
import type RecurringInviteModel from 'garaje/models/recurring-invite';
import RecurringRule from 'garaje/models/recurring-rule';
import type { GuestWithVisitApproval } from 'garaje/models/visit-approval';

/** A recurring invite whose series has not ended yet is not expired, whatever this occurrence's date. */
function hasFutureOccurrences(invite: Invite | undefined): boolean {
  const recurringInvite = invite?.belongsTo('recurringInvite').value() as RecurringInviteModel | null;
  const recurringRule = recurringInvite?.recurringRule;
  if (!recurringRule) return false;

  const { until } = RecurringRule.parse(recurringRule);
  return !until || isAfter(until, new Date());
}

/** A visit still awaiting review whose date has passed, so the review can no longer be acted on. */
export default function isVisitExpired(model: GuestWithVisitApproval): boolean {
  if (!model.needsApprovalReview) return false;

  const invite = model instanceof Invite ? model : undefined;
  const date = invite?.expectedArrivalTime || (model instanceof Entry ? model.signedInAt : undefined);
  const isBeforeToday = date ? isBefore(date, startOfDay(new Date())) : false;

  return isBeforeToday && !hasFutureOccurrences(invite);
}
